import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'

import { PanelSize } from '../panel-size'

@Component({
  selector: 'flx-bottom-panel',
  imports: [FlxIconModule, FlxButtonModule],
  templateUrl: './expandable-panel.component.html',
  styleUrl: './expandable-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { '[class]': 'className()' },
})
export class ExpandablePanelComponent {
  size = model<PanelSize>(PanelSize.SMALL)
  showToggleButtons = input(true)
  /**
   * Largest size this host allows. `MEDIUM` drops the expand-to-full step, which a host whose
   * containing block also holds a page header needs so the panel never covers that header.
   */
  maxSize = input<PanelSize>(PanelSize.LARGE)

  className = computed(() => this.size())

  readonly atMaxSize = computed((): boolean => this.size() === this.maxSize())

  readonly panelSize = PanelSize

  onPanelMinify(): void {
    this.size.set(this.size() === PanelSize.LARGE ? PanelSize.MEDIUM : PanelSize.SMALL)
  }

  onPanelExpand(): void {
    this.size.set(
      this.size() === PanelSize.MEDIUM && this.maxSize() === PanelSize.LARGE
        ? PanelSize.LARGE
        : PanelSize.MEDIUM
    )
  }

  togglePanel(): void {
    if (this.size() === PanelSize.SMALL) {
      this.size.set(PanelSize.MEDIUM)
    } else if (this.size() === PanelSize.MEDIUM || this.size() === PanelSize.LARGE) {
      this.size.set(PanelSize.SMALL)
    }
  }
}
